module.exports = __webpack_public_path__ + "img/Fill.d0a5b88a.svg";